'use client'

import { Base } from '@/ui/components'
import React, { memo, useImperativeHandle, useRef } from 'react'
import { BaseProps } from '../types'

interface Props extends BaseProps {
  children?: React.ReactNode
  ref?: React.RefObject<HTMLElement>
}

const Div = ({ className, children, ref, ...props }: Props) => {
  //refs
  const comp = useRef<any>(null)
  useImperativeHandle(ref, () => comp.current as HTMLElement)

  return (
    <Base ref={comp} {...props} className={className}>
      {children}
    </Base>
  )
}

Div.displayName = 'Div'

export default memo(Div)
